// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__4i3wI","fileBtn":"File_fileBtn__3Hn6j","closeBtn":"File_closeBtn__KZFDi","fileSelected":"File_fileSelected__HCYbC","disabled":"File_disabled__3TC58"};